<template>
  <div class="wrapper pt-5">
    <h1 class="title mb-5 text-center">
      Please enter your contact information
    </h1>

    <form
      @submit.prevent="submit"
      class="d-flex flex-column align-center flex-grow-1"
      novalidate
      autocomplete="off"
    >
      <v-text-field
        label="Coach First Name"
        solo
        class="searchInput flex-grow-0 mb-2"
        v-model="firstName"
      ></v-text-field>

      <v-text-field
        label="Coach Last Name"
        solo
        class="searchInput flex-grow-0 mb-2"
        v-model="lastName"
      ></v-text-field>

      <v-text-field
        label="Coach Email Address"
        solo
        class="searchInput flex-grow-0 mb-2"
        v-model="email"
        :error-messages="emailErrors"
        type="email"
      ></v-text-field>

      <div class="title mb-5 text-center">
        Are you a high school coach or a club coach?
      </div>

      <v-radio-group v-model="coachType" class="mt-0 mb-8" :hide-details="true">
        <v-radio label="Club" value="club"></v-radio>
        <v-radio label="High School" value="highSchool"></v-radio>
      </v-radio-group>

      <v-btn
        class="mb-8"
        large
        color="primary"
        :disabled="
          !$v.firstName.required || !$v.lastName.required || !$v.email.required
        "
        type="submit"
        >NEXT</v-btn
      >
    </form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      coachType: "club",
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    email: { required, email },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email)
        errors.push("Please enter a valid email format");
      return errors;
    },
  },
  created() {
    if (this.$store.state.coachType)
      this.coachType = this.$store.state.coachType;

    if (this.$store.state.coachInfo) {
      this.firstName = this.$store.state.coachInfo.firstName;
      this.lastName = this.$store.state.coachInfo.lastName;
      this.email = this.$store.state.coachInfo.email;
    }
  },
  methods: {
    ...mapMutations(["setCoachType", "setCoachInfo"]),
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.setCoachInfo({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
      });
      this.setCoachType(this.coachType);
      this.$router.push("/second");
    },
  },
};
</script>